import Information from '@reusable-modules/Information'
import LazyComponent from '@components/LazyComponent'

const InformationComponent = (props) => {
  if (props?.info_grp1_body?.includes('soundcloud')) {
    return <Information {...props} />
  }
  return (
    <LazyComponent
      id={props.id}
      placeholderType={5}
    ><Information {...props} />
    </LazyComponent>
  )
}

export default InformationComponent